module.exports = __webpack_public_path__ + "img/2.0ad12660.jpg";